import * as tiff from 'tiff';

export const get_ir_template_uint16 = async (ir_template_url) => {
  const irTemplateArrayBuffer = await load_ir_template(ir_template_url);
  const tiff_container = tiff.decode(irTemplateArrayBuffer)[0];
  // eslint-disable-next-line
  let _src = cv.matFromArray(tiff_container.height, tiff_container.width, cv.CV_16U, tiff_container.data);
  // eslint-disable-next-line no-undef
  let _dst = new cv.Mat();
  // eslint-disable-next-line no-undef
  cv.normalize(_src, _dst, 0, 255, cv.NORM_MINMAX, cv.CV_8UC1);
  _src.delete();
  return _dst;
};

export const get_ir_template_uint8 = async (ir_template_url) => {
  const irTemplateArrayBuffer = await load_ir_template(ir_template_url);
  // eslint-disable-next-line no-undef
  let _src = cv.matFromArray(height, width, cv.CV_8UC, irTemplateArrayBuffer);
  // eslint-disable-next-line no-undef
  cv.cvtColor(_src, _src, cv.COLOR_RGBA2GRAY);
  return _src;
};

export const prepare_mask = (in_mask_gray, p_dst) => {
  let tH_mask = 64; //CONFIG the quality black body active zone algorithm (affect on black body search time)
  let tW_mask = 64; //CONFIG the quality black body active zone algorithm (affect on black body search time)
  // eslint-disable-next-line no-undef
  let in_mask = cv.Mat.zeros(tW_mask, tH_mask, cv.CV_8UC1);

  // eslint-disable-next-line no-undef
  cv.rectangle(in_mask, new cv.Point(0, 0), new cv.Point(tW_mask - 1, tH_mask - 1), new cv.Scalar(cv.GC_BGD), -1);
  // eslint-disable-next-line no-undef
  cv.rectangle(
    in_mask,
    // eslint-disable-next-line no-undef
    new cv.Point(Math.round((1 * tW_mask) / 8), Math.round((1 * tH_mask) / 8)),
    // eslint-disable-next-line no-undef
    new cv.Point(Math.round((7 * tW_mask) / 8), Math.round((7 * tH_mask) / 8)),
    // eslint-disable-next-line no-undef
    new cv.Scalar(cv.GC_PR_BGD),
    -1,
  );
  // eslint-disable-next-line no-undef
  cv.rectangle(
    in_mask,
    // eslint-disable-next-line no-undef
    new cv.Point(Math.round((4 * tW_mask) / 16), Math.round((4 * tH_mask) / 16)),
    // eslint-disable-next-line no-undef
    new cv.Point(Math.round((12 * tW_mask) / 16), Math.round((12 * tH_mask) / 16)),
    // eslint-disable-next-line no-undef
    new cv.Scalar(cv.GC_PR_FGD),
    -1,
  );
  // eslint-disable-next-line no-undef
  cv.rectangle(
    in_mask,
    // eslint-disable-next-line no-undef
    new cv.Point(Math.round((7 * tW_mask) / 16), Math.round((7 * tH_mask) / 16)),
    // eslint-disable-next-line no-undef
    new cv.Point(Math.round((9 * tW_mask) / 16), Math.round((9 * tH_mask) / 16)),
    // eslint-disable-next-line no-undef
    new cv.Scalar(cv.GC_FGD),
    -1,
  );
  // eslint-disable-next-line no-undef
  let _p_dst = cv.matFromArray(4, 1, cv.CV_32FC2, [0, 0, tW_mask - 1, 0, tW_mask - 1, tH_mask - 1, 0, tH_mask - 1]);

  in_mask.copyTo(in_mask_gray);
  _p_dst.copyTo(p_dst);
};

export const bb_presence_check = (bb_template_saved, bb_template_current) => {
  // eslint-disable-next-line no-undef
  let _method = cv.TM_CCOEFF_NORMED;
  // eslint-disable-next-line no-undef
  let _dst = new cv.Mat();
  // eslint-disable-next-line no-undef
  cv.matchTemplate(bb_template_saved, bb_template_current, _dst, _method);
  let reference = _dst.data32F[0];
  _dst.delete();
  return reference;
};

export const best_multiscale_match = (frame, bb_template) => {
  let tH = bb_template.size()['height'];
  let tW = bb_template.size()['width'];
  // eslint-disable-next-line no-undef
  let _frame = new cv.Mat();
  // eslint-disable-next-line no-undef
  let _in_item = new cv.Mat();
  // eslint-disable-next-line no-undef
  let _location_mask = new cv.Mat();
  frame.copyTo(_frame);

  // eslint-disable-next-line no-undef
  let _method = cv.TM_CCOEFF_NORMED;
  // eslint-disable-next-line no-undef
  let _dst = new cv.Mat();

  let max_size = Math.max(_frame.size()['width'], _frame.size()['height']);
  let size_template_x = _frame.size()['width'] / max_size;
  let size_template_y = _frame.size()['height'] / max_size;
  let size_template = Math.min(size_template_x, size_template_y);

  let start_value = Math.round(Math.max(tW, tH) / size_template);
  // for factor in list(range(start_value, max_size)):
  let max_score = -1;
  let max_location = 0;
  let max_factor = 1;

  for (let factor = start_value; factor < max_size; factor++) {
    let _size_x = Math.round(size_template_x * factor);
    let _size_y = Math.round(size_template_y * factor);
    // eslint-disable-next-line no-undef
    cv.resize(_frame, _in_item, new cv.Size(_size_x, _size_y));
    // eslint-disable-next-line no-undef
    cv.matchTemplate(_in_item, bb_template, _dst, _method, _location_mask);
    // let reference = _dst.data32F[0];
    // eslint-disable-next-line no-undef
    let result = cv.minMaxLoc(_dst, _location_mask);
    if (result.maxVal > max_score) {
      max_score = result.maxVal;
      max_factor = factor;
      max_location = result.maxLoc;
    }
  }
  let xb1 = Math.round((max_location.x * max_size) / max_factor);
  let yb1 = Math.round((max_location.y * max_size) / max_factor);
  let xb2 = Math.round(((max_location.x + tW) * max_size) / max_factor);
  let yb2 = Math.round(((max_location.y + tH) * max_size) / max_factor);

  _location_mask.delete();
  _in_item.delete();
  _frame.delete();
  _dst.delete();

  return { xb1, yb1, xb2, yb2, max_score };
};

export const apply_grub_cut = (in_frame, in_mask) => {
  // eslint-disable-next-line no-undef
  var bgdModel = new cv.Mat();
  // eslint-disable-next-line no-undef
  var fgdModel = new cv.Mat();
  // eslint-disable-next-line no-undef
  var roiRect = new cv.Rect();
  let iter_count = 5;
  // eslint-disable-next-line no-undef
  cv.cvtColor(in_frame, in_frame, cv.COLOR_GRAY2RGB);
  // eslint-disable-next-line no-undef
  in_mask.convertTo(in_mask, cv.CV_8U);
  // eslint-disable-next-line no-undef
  in_frame.convertTo(in_frame, cv.CV_8UC3);
  // eslint-disable-next-line no-undef
  cv.grabCut(in_frame, in_mask, roiRect, bgdModel, fgdModel, iter_count, cv.GC_INIT_WITH_MASK);
  for (let i = 0; i < in_mask.data.length; i++) {
    // eslint-disable-next-line no-undef
    if ((in_mask.data[i] === cv.GC_FGD) | (in_mask.data[i] === cv.GC_PR_FGD)) {
      in_mask.data[i] = 255;
    } else {
      in_mask.data[i] = 0;
    }
  }
};

export const bb_get_zone = (_frame, _in_mask, p_src, p_dst, config_ksize) => {
  // eslint-disable-next-line no-undef
  let M = cv.getPerspectiveTransform(p_src, p_dst);
  // eslint-disable-next-line no-undef
  let _frame_aliged = new cv.Mat();
  // eslint-disable-next-line no-undef
  cv.warpPerspective(_frame, _frame_aliged, M, _in_mask.size(), cv.INTER_LINEAR, cv.BORDER_CONSTANT, new cv.Scalar());
  apply_grub_cut(_frame_aliged, _in_mask);
  // eslint-disable-next-line no-undef
  let ksize = new cv.Size(config_ksize, config_ksize);
  // You can try more different parameters
  // eslint-disable-next-line no-undef
  let kernel = cv.getStructuringElement(cv.MORPH_ELLIPSE, ksize);
  // eslint-disable-next-line no-undef
  cv.erode(_in_mask, _in_mask, kernel);
};

export const load_ir_template = async (ir_template_url) => {
  const irTemplateResponse = await fetch(ir_template_url);
  const irTemplateContent = await irTemplateResponse.body.getReader().read();
  return irTemplateContent.value;
};

export const detectBlackBody = async (thermalData) => {
  // eslint-disable-next-line no-undef
  let in_frame_src = cv.matFromArray(thermalData.height, thermalData.width, cv.CV_16U, thermalData.data);
  // eslint-disable-next-line no-undef
  let in_frame_gray = new cv.Mat();
  // eslint-disable-next-line no-undef
  cv.normalize(in_frame_src, in_frame_gray, 0, 255, cv.NORM_MINMAX, cv.CV_8UC1);

  // let bb_ir_template = await get_ir_template_uint8('/bb_templates/bb_ir_template.png');
  let bb_ir_template = await get_ir_template_uint16('/bb_templates/bb_ir_template.tiff');

  // CONFIG - this will affect realtime performance (ussed on every nth frame to check BB presence)
  let tW_check = 32;
  // CONFIG - this will affect realtime performance (ussed on every nth frame to check BB presence)
  let tH_check = 32;
  // eslint-disable-next-line no-undef
  let p_dst_check = cv.matFromArray(4, 1, cv.CV_32FC2, [
    0,
    0,
    tW_check - 1,
    0,
    tW_check - 1,
    tH_check - 1,
    0,
    tH_check - 1,
  ]);
  // eslint-disable-next-line no-undef
  let bb_check_template = new cv.Mat();
  // eslint-disable-next-line no-undef
  let bb_current_template = new cv.Mat();

  // eslint-disable-next-line no-undef
  let in_mask_gray = new cv.Mat();
  // eslint-disable-next-line no-undef
  let aligned_mask_gray = new cv.Mat();
  // eslint-disable-next-line no-undef
  let out_mask = new cv.Mat();
  // eslint-disable-next-line no-undef
  let p_dst = new cv.Mat();
  // eslint-disable-next-line no-undef
  let p_src = new cv.Mat();
  // eslint-disable-next-line no-undef
  let M_check = new cv.Mat();
  // eslint-disable-next-line no-undef
  let iM = new cv.Mat();
  prepare_mask(in_mask_gray, p_dst);
  let bb_detected = false;
  // TODO: Ideally these parameters should be moved to the configuration
  let score_detect_threshold = 0.95;
  // TODO: Ideally these parameters should be moved to the configuration
  let score_check_threshold = 0.97;
  let bbCoordinates = [];

  //For earch frame
  if (bb_detected) {
    //Check black body move
    // eslint-disable-next-line no-undef
    cv.warpPerspective(
      in_frame_gray,
      bb_current_template,
      M_check,
      // eslint-disable-next-line no-undef
      new Size(tW_check, tH_check),
      // eslint-disable-next-line no-undef
      cv.INTER_LINEAR,
      // eslint-disable-next-line no-undef
      cv.BORDER_CONSTANT,
      // eslint-disable-next-line no-undef
      new cv.Scalar(),
    );
    let check_score = bb_presence_check(bb_check_template, bb_current_template);
    if (check_score < score_check_threshold) {
      bb_detected = false;
    }
  }

  if (!bb_detected) {
    let { xb1, yb1, xb2, yb2, max_score } = best_multiscale_match(in_frame_gray, bb_ir_template);

    if (max_score > score_detect_threshold) {
      // eslint-disable-next-line no-undef
      p_src = cv.matFromArray(4, 1, cv.CV_32FC2, [xb1, yb1, xb2, yb1, xb2, yb2, xb1, yb2]);
      in_mask_gray.copyTo(aligned_mask_gray);

      // CONFIG This value should be placed in to the config. We should make mask smaller because of black body irradiation field
      let config_ksize = 7;
      bb_get_zone(in_frame_gray, aligned_mask_gray, p_src, p_dst, config_ksize);

      // eslint-disable-next-line no-undef
      iM = cv.getPerspectiveTransform(p_dst, p_src);
      // eslint-disable-next-line no-undef
      cv.warpPerspective(
        aligned_mask_gray,
        out_mask,
        iM,
        in_frame_gray.size(),
        // eslint-disable-next-line no-undef
        cv.INTER_LINEAR,
        // eslint-disable-next-line no-undef
        cv.BORDER_CONSTANT,
        // eslint-disable-next-line no-undef
        new cv.Scalar(),
      );

      // eslint-disable-next-line no-undef
      let contours = new cv.MatVector();
      // eslint-disable-next-line no-undef
      let hierarchy = new cv.Mat();
      // eslint-disable-next-line no-undef
      cv.threshold(out_mask, out_mask, 127, 255, cv.THRESH_BINARY);
      // eslint-disable-next-line no-undef
      cv.findContours(out_mask, contours, hierarchy, cv.RETR_CCOMP, cv.CHAIN_APPROX_SIMPLE);
      // eslint-disable-next-line no-undef
      const ContounrBoundingRect = cv.boundingRect(contours.get(0));

      // Take a look for the OpenCV Garbage Collection
      // https://gist.github.com/janpaul123/8b9061d1d093ec0b36dac2230434d34a
      for (let i = 0; i < contours.size(); i++) {
        contours.get(i).delete();
      }
      // We should define min_contour area
      let min_contour = 128;
      // eslint-disable-next-line no-undef
      const area = cv.contourArea(contours.get(0));
      console.assert(area > min_contour);
      // We should detect only one contour
      console.assert(contours.size() === 1);
      hierarchy.delete();
      contours.delete();

      // active zone coordinates x1,y1,x2,y2
      bbCoordinates = [
        ContounrBoundingRect['x'],
        ContounrBoundingRect['y'],
        ContounrBoundingRect['x'] + ContounrBoundingRect['width'],
        ContounrBoundingRect['y'] + ContounrBoundingRect['height'],
      ];

      //Saving template for check of black body move
      // eslint-disable-next-line no-undef
      M_check = cv.getPerspectiveTransform(p_src, p_dst_check);
      // eslint-disable-next-line no-undef
      cv.warpPerspective(
        in_frame_gray,
        bb_check_template,
        M_check,
        // eslint-disable-next-line no-undef
        new cv.Size(tW_check, tH_check),
        // eslint-disable-next-line no-undef
        cv.INTER_LINEAR,
        // eslint-disable-next-line no-undef
        cv.BORDER_CONSTANT,
        // eslint-disable-next-line no-undef
        new cv.Scalar(),
      );
    }
  }

  p_dst_check.delete();
  bb_check_template.delete();
  bb_current_template.delete();
  M_check.delete();
  iM.delete();
  p_dst.delete();
  p_src.delete();
  out_mask.delete();
  aligned_mask_gray.delete();
  in_mask_gray.delete();
  bb_ir_template.delete();
  in_frame_src.delete();
  in_frame_gray.delete();

  console.log('Black body coordinates | Auto :: ', bbCoordinates);
  // console.log('Black body coordinates | Manual :: ', [84, 120, 109, 150]);
  return bbCoordinates;
};
